import DashboardIcon from "@/assets/dashboard.svg";
import ActivitiesIcon from "@/assets/Icon.svg";
import FormsIcon from "@/assets/lets-icons_form.svg";
import DocumentsIcon from "@/assets/majesticons_document-line.svg";
import CompaniesIcon from "@/assets/material-symbols_handshake-outline.svg";
import ContactsIcon from "@/assets/material-symbols_phone-outline.svg";

import { Box } from "@mui/material";

export const items = [
  {
    title: "Dashboard",
    path: "/",
    icon: (
      <Box
        component="img"
        src={DashboardIcon}
        alt="Dashboard"
        sx={{
          width: 20,
          height: 20,
          objectFit: "contain",
        }}
      />
    ),
    disabled: false,
    external: false,
  },
  // {
  //   title: "Users",
  //   path: "/users",
  //   icon: (
  //     <SvgIcon fontSize="small">
  //       <PeopleIcon />
  //     </SvgIcon>
  //   ),
  //   disabled: false,
  //   external: false,
  // },
  {
    title: "Activities",
    path: "/activities",
    icon: (
      <Box
        component="img"
        src={ActivitiesIcon}
        alt="Activities"
        sx={{
          width: 20,
          height: 20,
          objectFit: "contain",
        }}
      />
    ),
    disabled: false,
    external: false,
  },
  {
    title: "Forms",
    path: "/forms",
    icon: (
      <Box
        component="img"
        src={FormsIcon}
        alt="Forms"
        sx={{
          width: 20,
          height: 20,
          objectFit: "contain",
        }}
      />
    ),
    disabled: false,
    external: false,
  },
  {
    title: "Submitted Forms",
    path: "/all-forms",
    icon: (
      <Box
        component="img"
        src={FormsIcon}
        alt="Submitted Forms"
        sx={{
          width: 20,
          height: 20,
          objectFit: "contain",
        }}
      />
    ),
    disabled: false,
    external: false,
  },
  {
    title: "Users",
    path: "/guides",
    icon: (
      <Box
        component="img"
        src={FormsIcon}
        alt="Users"
        sx={{
          width: 20,
          height: 20,
          objectFit: "contain",
        }}
      />
    ),
    disabled: false,
    external: false,
  },
  {
    title: "Documents",
    path: "/documents",
    icon: (
      <Box
        component="img"
        src={DocumentsIcon}
        alt="Documents"
        sx={{
          width: 20,
          height: 20,
          objectFit: "contain",
        }}
      />
    ),
    disabled: false,
    external: false,
  },
  {
    title: "Companies",
    path: "/companies",
    icon: (
      <Box
        component="img"
        src={CompaniesIcon}
        alt="Companies"
        sx={{
          width: 20,
          height: 20,
          objectFit: "contain",
        }}
      />
    ),
    disabled: false,
    external: false,
  },
  {
    title: "Contacts",
    path: "/contacts",
    icon: (
      <Box
        component="img"
        src={ContactsIcon}
        alt="Contacts"
        sx={{
          width: 20,
          height: 20,
          objectFit: "contain",
        }}
      />
    ),
    disabled: false,
    external: false,
  },

  // {
  //   title: "Manage Data",
  //   path: "/manage-data",
  //   icon: (
  //     <SvgIcon fontSize="small">
  //       <TimeToLeaveIcon />
  //     </SvgIcon>
  //   ),
  //   disabled: false,
  //   external: false,
  // },
  // {
  //   title: "Manage Offers",
  //   path: "/offers",
  //   icon: (
  //     <SvgIcon fontSize="small">
  //       <LoyaltyIcon />
  //     </SvgIcon>
  //   ),
  //   disabled: false,
  //   external: false,
  // },

  // {
  //   title: "Manage Vehicles",
  //   path: "/vehicles",
  //   icon: (
  //     <SvgIcon fontSize="small">
  //       <LocalShippingIcon />
  //     </SvgIcon>
  //   ),
  //   disabled: false,
  //   external: false,
  // },
  // {
  //   title: "Media Gallery",
  //   path: "/media-gallery",
  //   icon: (
  //     <SvgIcon fontSize="small">
  //       <CollectionsIcon />
  //     </SvgIcon>
  //   ),
  //   disabled: false,
  //   external: false,
  // },

  // {
  //   title: "Ad Management",
  //   path: "/advertisement",
  //   icon: (
  //     <SvgIcon fontSize="small">
  //       <AdUnitsIcon />
  //     </SvgIcon>
  //   ),
  //   disabled: false,
  //   external: false,
  // },
  // {
  //   title: "Popular Search",
  //   path: "/popular-search",
  //   icon: (
  //     <SvgIcon fontSize="small">
  //       <AdUnitsIcon />
  //     </SvgIcon>
  //   ),
  //   disabled: false,
  //   external: false,
  // },
  // {
  //   title: "Feature Model",
  //   path: "/feature-model",
  //   icon: (
  //     <SvgIcon fontSize="small">
  //       <AdUnitsIcon />
  //     </SvgIcon>
  //   ),
  //   disabled: false,
  //   external: false,
  // },
  // {
  //   title: "Feature Article",
  //   path: "/feature-article",
  //   icon: (
  //     <SvgIcon fontSize="small">
  //       <AdUnitsIcon />
  //     </SvgIcon>
  //   ),
  //   disabled: false,
  //   external: false,
  // },
  // {
  //   title: "Configuration",
  //   path: "/configuration",
  //   icon: (
  //     <SvgIcon fontSize="small">
  //       <CogIcon />
  //     </SvgIcon>
  //   ),
  //   disabled: false,
  //   external: false,
  // },
];
